import { useNavigate } from 'react-router-dom';
import { Card, message, theme } from 'antd';
import { PageHeader } from '../../components/PageHeader';
import { TipoServicioForm } from './components/TipoServicioForm';
import { useCreateTipoServicio } from './api/useTiposServicio';
import { useHasPermission } from '../../auth/useHasPermission';
import { Permission } from '@aid/shared';

export function TipoServicioCreatePage() {
  const navigate = useNavigate();
  const createTipoServicio = useCreateTipoServicio();
  const hasPermission = useHasPermission(Permission.TIPOS_SERVICIO_CREATE);
  const { token } = theme.useToken();

  if (!hasPermission) {
    return <div>No tienes permiso para crear tipos de servicio.</div>;
  }

  const handleSubmit = async (values: Record<string, unknown>) => {
    try {
      await createTipoServicio.mutateAsync(
        values as Parameters<typeof createTipoServicio.mutateAsync>[0],
      );
      message.success('Tipo de servicio creado correctamente');
      navigate('/tipos-servicio');
    } catch {
      message.error('Error al crear el tipo de servicio');
    }
  };

  return (
    <div>
      <PageHeader title="Crear tipo de servicio" subtitle="Crear un nuevo tipo de servicio" />
      <Card
        style={{
          borderRadius: 12,
          border: `1px solid ${token.colorBorderSecondary}`,
          boxShadow: token.boxShadow,
        }}
      >
        <TipoServicioForm
          mode="create"
          onSubmit={handleSubmit}
          loading={createTipoServicio.isPending}
        />
      </Card>
    </div>
  );
}
